import { saveGrupe, saveGrupaRoba } from "./db";

const API_URL = "https://rodendaonica.com/get_data.php"; // Promijeni ako treba

export const fetchAndStoreData = async () => {
    try {
        const response = await fetch(API_URL,
            {
                method: "POST",
                headers:{
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(
                    {
                        Funkcija:"Grupa",

                    }),
            });
        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();

        if (data.error) throw new Error(data.error);

        // Spremanje podataka u IndexedDB
        await saveGrupe(data);
        //await saveGrupaRoba(data.grupaRoba);

        console.log("Podaci uspješno spremljeni u IndexedDB");
    } catch (error) {
        console.error("Greška kod dohvaćanja podataka:", error);
    }
};
